module.exports = __webpack_public_path__ + "img/add1.36a890bc.png";